module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-7.50eeed03.png";